export default __webpack_public_path__ + "static/media/m_use_action_back_hk.beed981f.png";